import { WeightsDto } from '../../apis/user-preferences';

export interface AlgorithmSetting {
  id: keyof WeightsDto;
  name: string;
  description: string;
  color: string;
  examples?: {
    low: string;
    high: string;
  };
}

export const algorithmSettings: AlgorithmSetting[] = [
  {
    id: 'educationalValueWeight',
    name: 'Educational Value',
    description: 'Content that provides knowledge, insights, or actionable takeaways',
    color: 'blue.500',
    examples: {
      low: 'Entertainment, memes, casual posts',
      high: 'Tutorials, research papers, skill guides'
    }
  },
  {
    id: 'lightheartednessWeight',
    name: 'Lightheartedness',
    description: 'Balance between serious content and lighthearted/humorous tone',
    color: 'yellow.500',
    examples: {
      low: 'Serious news, academic papers, formal analysis',
      high: 'Memes, comedy, casual observations'
    }
  },
  {
    id: 'contentQualityWeight',
    name: 'Content Quality',
    description: 'Writing clarity, coherence, evidence use, and logical flow',
    color: 'green.500',
    examples: {
      low: 'Quick posts, stream-of-consciousness',
      high: 'Well-structured articles, peer-reviewed content'
    }
  },
  {
    id: 'contentTrustworthinessWeight',
    name: 'Trustworthiness',
    description: 'Factual accuracy, source credibility, and transparency in reasoning',
    color: 'teal.500',
    examples: {
      low: 'Opinion pieces, unverified claims',
      high: 'Fact-checked journalism, scientific studies'
    }
  },
  {
    id: 'clickbaitWeight',
    name: 'Clickbait Resistance',
    description: 'Avoid sensationalist headlines and exaggerated claims',
    color: 'orange.500'
  },
  {
    id: 'integrityWeight',
    name: 'Content Integrity',
    description: 'Good faith arguments that fairly represent different perspectives',
    color: 'cyan.500'
  },
  {
    id: 'civilityWeight',
    name: 'Civility',
    description: 'Respectful, constructive language and tone',
    color: 'purple.500'
  },
  {
    id: 'recencyWeight',
    name: 'Recency',
    description: 'Prioritize newer content over older articles',
    color: 'blue.300'
  },
  {
    id: 'perspectiveDiversityWeight',
    name: 'Perspective Diversity',
    description: 'Content that considers multiple viewpoints on a topic',
    color: 'purple.300'
  },
  {
    id: 'originalityWeight',
    name: 'Originality',
    description: 'Unique or innovative perspectives rather than derivative content',
    color: 'pink.500'
  },
  {
    id: 'sentimentWeight',
    name: 'Sentiment',
    description: 'Preference for positive vs negative sentiment in content',
    color: 'teal.300'
  },
  // {
  //   id: 'politicalBiasWeight',
  //   name: 'Political Neutrality',
  //   description: 'Preference for politically neutral content over biased perspectives',
  //   color: 'gray.500'
  // }
];
